import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '../ui/tabs';
import PRHeaderTab from './tabs/PRHeaderTab';
import PRItemOverviewTab from './tabs/PRItemOverviewTab';
import PRItemDetailsTab from './tabs/PRItemDetailsTab';
import PRValuationTab from './tabs/PRValuationTab';
import PRAccountAssignmentTab from './tabs/PRAccountAssignmentTab';

/**
 * Shared tabbed body for the PR Create and PR Edit forms.
 * `variant` ('create' | 'edit') preserves the small behavioral differences
 * between the two pages (item-category select, MRP/UoM as dropdown vs input).
 */
const PRFormBody = ({
  variant,
  formData,
  masterData,
  activeTab,
  setActiveTab,
  activeItemIndex,
  setActiveItemIndex,
  materialPlants,
  handleHeaderChange,
  handleItemChange,
  addItem,
  removeItem,
}) => {
  const currentItem = formData.items[activeItemIndex];

  return (
    <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
      <TabsList className="grid w-full grid-cols-5 mb-4">
        <TabsTrigger value="header" data-testid="pr-tab-header">PR Header</TabsTrigger>
        <TabsTrigger value="items" data-testid="pr-tab-items">Item Overview</TabsTrigger>
        <TabsTrigger value="item-details" data-testid="pr-tab-item-details">Item Details</TabsTrigger>
        <TabsTrigger value="valuation" data-testid="pr-tab-valuation">Valuation</TabsTrigger>
        <TabsTrigger value="account" data-testid="pr-tab-account">Account Assignment</TabsTrigger>
      </TabsList>

      <PRHeaderTab formData={formData} handleHeaderChange={handleHeaderChange} masterData={masterData} />

      <PRItemOverviewTab
        formData={formData}
        masterData={masterData}
        currentItem={currentItem}
        activeItemIndex={activeItemIndex}
        handleItemChange={handleItemChange}
        addItem={addItem}
        removeItem={removeItem}
        setActiveItemIndex={setActiveItemIndex}
        variant={variant}
      />

      <PRItemDetailsTab
        masterData={masterData}
        currentItem={currentItem}
        activeItemIndex={activeItemIndex}
        handleItemChange={handleItemChange}
        materialPlants={materialPlants}
        variant={variant}
      />

      <PRValuationTab
        masterData={masterData}
        currentItem={currentItem}
        activeItemIndex={activeItemIndex}
        handleItemChange={handleItemChange}
        variant={variant}
      />

      <PRAccountAssignmentTab
        masterData={masterData}
        currentItem={currentItem}
        activeItemIndex={activeItemIndex}
        handleItemChange={handleItemChange}
      />
    </Tabs>
  );
};

export default PRFormBody;
